/**
 * Search as people type it: case and accents ignored, every typed word must
 * appear somewhere (in any order), across all the texts given. "code postal"
 * finds "Adresse › Code postal", "telephone urgence" finds "Contact
 * d'urgence › Téléphone", in either language when both labels are passed.
 */

/** Lowercase, no accents, punctuation as spaces: "Téléphone" → "telephone". */
export const foldText = (value: string | null | undefined): string =>
  (value ?? '')
    .normalize('NFD')
    .replace(/\p{M}/gu, '')
    .toLowerCase()
    .replace(/[^\p{L}\p{N}]+/gu, ' ')
    .trim();

/** Whether every word of `search` is found in one of `texts`. */
export const matchesSearch = (
  texts: (string | null | undefined)[],
  search: string
): boolean => {
  const words = foldText(search).split(' ').filter(Boolean);
  if (!words.length) return true;
  const haystack = ` ${texts.map(foldText).join(' ')} `;
  return words.every((word) => haystack.includes(word));
};

/**
 * A cmdk `filter` built on {@link matchesSearch}: the item's value and its
 * keywords (labels in both languages, a group name) are searched.
 */
export const wordsFilter = (
  value: string,
  search: string,
  keywords?: string[]
): number => (matchesSearch([value, ...(keywords ?? [])], search) ? 1 : 0);
